"use strict";

module.exports = {
  setInstance: function setInstance(webApiClientInstance) {
    this.instance = webApiClientInstance;
  }
};
//# sourceMappingURL=webApiClientSingleton.js.map